<template>
  <div>
    {{ $options.name }}
  </div>
</template>

<script>
export default {
  name: 'MachineIndex',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resource/machine/Index.vue